import React from 'react'
import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

// Registrar los componentes de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const KpiGraphics = ({
  data,
  titlelabelStatus = 'Número de reportes por estatus',
  titlelabelPlatform = 'Cantidad de reportes por plataforma',
  titleLabelsStatus = ['Completados', 'Pendientes', 'Cancelados'],
  titleLabelsPlatform = ['Web', 'App', 'TlajoChat'],
  barPlatform = true,
}) => {
  const {
    total,
    pending,
    completed,
    canceled,
    averageCompleted,
    tlajochat,
    web,
    app,
  } = data

  const barDataStatus = {
    labels: titleLabelsStatus,
    datasets: [
      {
        label: titlelabelStatus,
        data: [completed, pending, canceled],
        backgroundColor: ['#F97316', '#F97316', '#F97316'],
        borderColor: ['#388e3c', '#f57c00', '#d32f2f'],
        borderWidth: 1,
        maxBarThickness: 140,
      },
    ],
  }

  const barDataPlatform = {
    labels: titleLabelsPlatform,
    datasets: [
      {
        label: titlelabelPlatform,
        data: [web, app, tlajochat],
        backgroundColor: ['#F97316', '#F97316', '#F97316'],
        borderColor: ['#388e3c', '#f57c00', '#d32f2f'],
        borderWidth: 1,
        maxBarThickness: 140,
      },
    ],
  }

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  }

  return (
    <div className="px-1 kpi-graphics">
      <div className="row kpi-card-container kpi-card-containerMini">
        <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <KpiCard
            title="Tasa de éxito"
            value={`${
              Number.isInteger(data.averageCompleted)
                ? data.averageCompleted
                : (data.averageCompleted ?? 0).toFixed(2)
            }%`}
          />
        </div>
        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
          <div className="row">
            <div
              className={` ${
                barPlatform
                  ? 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'
                  : 'col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8'
              }`}
            >
              <Bar data={barDataStatus} options={barOptions} />
            </div>
            {barPlatform && (
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Bar data={barDataPlatform} options={barOptions} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const KpiCard = ({
  iconContent = <i className="fas fa-id-badge colorOrange" />,
  title = '',
  value = '',
}) => {
  return (
    <div className="kpi-card">
      <div className="kpi-card-header">
        <span className="kpi-icon icon-primary">{iconContent}</span>
      </div>
      <div className="kpi-card-body">
        <h6>{title}</h6>
        <p className="kpi-value">{value}</p>
      </div>
    </div>
  )
}

KpiGraphics.propTypes = {
  data: PropTypes.shape({
    total: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    canceled: PropTypes.number.isRequired,
    averageCompleted: PropTypes.number.isRequired,
    tlajochat: PropTypes.number.isRequired,
    web: PropTypes.number.isRequired,
    app: PropTypes.number.isRequired,
  }).isRequired,
}

export default KpiGraphics
